/* eslint-disable import/no-extraneous-dependencies */
import axios from "axios";
import config from "@/config/indo";
import axiosConfig from "@/config/axios";
import formatDate from "@/helpers/dates";
import { json2xml } from "@/helpers/xml";

import ofertas from "./ofertas";
import indobisel from "./indobisel";
import academy from "./academy";
import indoscan from "./indoscan";
import indobox from "./indobox";
import mimetikaId from "./mimetikaId";
import response from "./response";
import { useIndoStore } from "@/stores/indo";
import { getSoapIdioma } from "@/utils/soapIdioma";

// Detecta organización de ventas según la brand de la URL
// Busca dinámicamente en listaAreasCliente del profile del store
const getOrgVentasFromUrl = () => {
  const currentPath = window.location.pathname.toLowerCase();
  const listaAreas = useIndoStore().profile?.AreaVenta?.listaAreasCliente || [];

  for (const area of listaAreas) {
    if (area.TEXTO_ORGANIZACION && currentPath.includes(area.TEXTO_ORGANIZACION.toLowerCase())) {
      return area.ORG_VENTA;
    }
  }

  return "";
};

export default {
  ofertas: { ...ofertas },
  indobisel: { ...indobisel },
  academy: { ...academy },
  indoscan: { ...indoscan },
  indobox: { ...indobox },
  mimetikaId: { ...mimetikaId },

  login(username, password) {
    return axios.post(
      axiosConfig.indonetURL,
      config.login.xml
        .replace("{username}", username)
        .replace("{password}", password)
        .replace("{idioma}", getSoapIdioma()),
      {
        headers: axiosConfig.headers,
        skipAuth: true,
      },
    );
  },

  // `skipAuth`: sin Authorization y fuera del manejo de token caducado del
  // interceptor (el refresh/logout gestionan su propio resultado).
  renovarToken(refreshToken) {
    return axios.post(
      axiosConfig.indonetURL,
      config.renovarToken.xml.replace("{refreshToken}", refreshToken),
      {
        headers: axiosConfig.headers,
        skipAuth: true,
        silentError: true,
        timeout: 15000,
      },
    );
  },

  cerrarSesion(refreshToken) {
    return axios.post(
      axiosConfig.indonetURL,
      config.cerrarSesion.xml.replace("{refreshToken}", refreshToken),
      {
        headers: axiosConfig.headers,
        skipAuth: true,
        silentError: true,
        timeout: 5000,
      },
    );
  },

  loginManager(username, password) {
    return axios.post(
      axiosConfig.indonetURL,
      config.loginManager.xml.replace("{username}", username).replace("{password}", password),
      {
        headers: axiosConfig.headers,
      },
    );
  },

  changePassword(Cliente, password, NewPassword, VerifyPassword, token) {

    const xmlPayload = config.ChangePassword.xml
      .replace("{Cliente}", Cliente)
      .replace("{password}", password)
      .replace("{NewPassword}", NewPassword)
      .replace("{VerifyPassword}", VerifyPassword);


    return axios.post(axiosConfig.indoboxURL, xmlPayload, {
      headers: {
        ...axiosConfig.headers,
        SOAPAction: "http://WSINDOBOX.es/CambioPasswordIM",
      },
    });
  },

  postLogin(username, token) {
    return axios.post(
      axiosConfig.indonetURL,
      config.postLogin.xml.replace("{username}", username),
      {
        headers: {
          ...axiosConfig.headers,
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },

  getPedidos(username, token, profile, fechaIni, fechaFin, extras = {}) {
    const payload = config.pedidos.xml
      .replace("{username}", username)
      .replace("{org}", profile.AreaVenta.ORG_VENTA)
      .replace("{canal}", profile.AreaVenta.CANAL_DIST)
      .replace("{sector}", profile.AreaVenta.SECTOR)
      .replace("{fecha_ini}", fechaIni)
      .replace("{fecha_fin}", fechaFin)
      .replace("{numPedido}", extras.numPedido || "")
      .replace("{referencia}", extras.referencia || "")
      .replace("{producto}", extras.producto || "")
      .replace("{esfera}", extras.esfera || "")
      .replace("{cilindro}", extras.cilindro || "")
      .replace("{adicion}", extras.adicion || "")
      .replace("{numAlbaran}", extras.numAlbaran || "")
      .replace("{grabado}", extras.grabado || "T")
      .replace("{todosLosSolicitantes}", extras.todosLosSolicitantes ? "true" : "false")
      .replace("{ESTADO}", extras.estado || "")
      .replace("{idioma}", getSoapIdioma());

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getNuevoPedido(token, org, xmlAreaVenta, xmlDatosConfig) {
    const payload = config.nuevoPedido.xml;

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getContactosATC(token) {
    const payload = config.contactosATC.xml;

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  saveAjustes(xmlDatosConfig, token) {
    const payload = config.ajustes.xml.replace("{datosConfig}", xmlDatosConfig);
    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  recuperarDatosOptica(cliente, organizacion, canal, token) {
    const payload = config.recuperarDatosOptica.xml
      .replace("{cliente}", cliente)
      .replace("{organizacion}", organizacion)
      .replace("{canal}", canal);
    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  saveMailbox(xmlDatosConfig, token) {
    const payload = config.miBuzon.xml.replace("{datosConfig}", xmlDatosConfig);
    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  cambioPassword(username, password, newPassword, token) {
    const payload = config.cambioPassword.xml
      .replace("{username}", username)
      .replace("{old_pass}", password)
      .replace("{new_pass}", newPassword);
    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  searchManagerFacturas(
    token,
    manager,
    from,
    to,
    T,
    noclient = "",
    nofact = "",
    noalb = "",
  ) {
    const payload = config.buscarListaFacturas.xml
      .replace("{cliente}", manager.CLIENTESAP)
      .replace("{solicitante}", noclient || "")
      .replace("{org}", getOrgVentasFromUrl())
      .replace("{canal}", manager.CANAL_DISTRIBUCION)
      .replace("{sector}", manager.SECTOR)
      .replace("{fecha_inicio}", from)
      .replace("{fecha_fin}", to)
      .replace("{tipo_factura}", T)
      .replace("{albaran}", noalb)
      .replace("{pedido}", "")
      .replace("{referencia}", "")
      .replace("{factura}", nofact)
      .replace("{idioma}", "");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  searchPendientesFacturar(username, token, manager) {
    const payload = config.buscarPendientesFacturar.xml
      .replace("{solicitante}", username)
      .replace("{cliente}", manager.CLIENTESAP.replace(/^0+/, ""))
      .replace("{org}", getOrgVentasFromUrl())
      .replace("{canal}", manager.CANAL_DISTRIBUCION)
      .replace("{sector}", manager.SECTOR)
      .replace("{idioma}", "");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getBonos(username, token, manager, solicitante = "") {
    const payload = config.bonos.xml
      .replace("{cliente}", manager.CLIENTE)
      .replace("{solicitante}", solicitante)
      .replace("{org}", getOrgVentasFromUrl())
      .replace("{canal}", manager.CANAL_DISTRIBUCION)
      .replace("{sector}", manager.SECTOR)
      .replace("{idioma}", "ES");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  async getFacturaSap(username, token, manager, factura, fechaFactura) {
    const payload = config.facturaSap.xml
      .replace("{cliente}", String(manager).replace(/^0+/, ""))
      .replace("{solicitante}", String(username).replace(/^0+/, ""))
      .replace("{factura}", factura)
      .replace("{fecha_factura}", fechaFactura)
      .replace("{ip}", "");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getBonoDetalle(token, manager, bono) {
    const payload = config.bonoDetalle.xml
      .replace("{cliente}", manager.CLIENTESAP)
      .replace("{bono}", bono)
      .replace("{org}", getOrgVentasFromUrl())
      .replace("{canal}", manager.CANAL_DISTRIBUCION)
      .replace("{sector}", manager.SECTOR)
      .replace("{idioma}", "ES");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getEstadisticaServicio(token, manager, fechas = {}) {
    const { mesIni = "1", anyoIni = "2023", mesFin = "7", anyoFin = "2023" } = fechas;

    const payload = config.estadisticaServicio.xml
      .replace("{cliente}", manager.CLIENTE)
      .replace("{org}", getOrgVentasFromUrl())
      .replace("{mes_ini}", mesIni.toString())
      .replace("{anyo_ini}", anyoIni.toString())
      .replace("{mes_fin}", mesFin.toString())
      .replace("{anyo_fin}", anyoFin.toString())
      .replace("{idioma}", "ES");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getEstadisticaConsumo(token, manager, fechas = {}) {
    const { mesIni = "1", anyoIni = "2023", mesFin = "7", anyoFin = "2023" } = fechas;

    const payload = config.estadisticaConsumo.xml
      .replace("{cliente}", manager.CLIENTE)
      .replace("{org}", getOrgVentasFromUrl())
      .replace("{mes_ini}", mesIni.toString())
      .replace("{anyo_ini}", anyoIni.toString())
      .replace("{mes_fin}", mesFin.toString())
      .replace("{anyo_fin}", anyoFin.toString())
      .replace("{idioma}", "ES");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  enviarEmail(token, to, subject, body) {
    const payload = config.enviarEmail.xml
      .replace("{to}", to)
      .replace("{subject}", subject)
      .replace("{body}", body);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getBases(token, xmlPedido) {
    const payload = config.basesEspeciales.xml
      .replace("{oClaseApi}", xmlPedido)
      .replace("{idioma}", getSoapIdioma());

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  prepararPedido(token, xmlPedido, idioma) {
    // calcular
    const payload = config.prepararPedido.xml
      .replace("{oClaseApi}", xmlPedido)
      .replace("{idioma}", idioma);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  reportarErrorPedido(token, params) {
    const { nombreUsuario, emailUsuario, mensajeUsuario, errores, oClaseApiXml, idioma } = params;
    const payload = config.reportarErrorPedido.xml
      .replace("{nombre_usuario}", nombreUsuario)
      .replace("{email_usuario}", emailUsuario)
      .replace("{mensaje_usuario}", mensajeUsuario)
      .replace("{errores}", errores)
      .replace("{oClaseApi}", oClaseApiXml)
      .replace("{idioma}", idioma);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  realizarPedido(token, xmlPedido, idioma) {
    // calcular
    const payload = config.realizarPedido.xml
      .replace("{oClaseApi}", xmlPedido)
      .replace("{idioma}", idioma);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getPedidoByNumero(
    token,
    profile,
    numeroPedido,
    vkorg = null,
    vtweg = null,
    spart = null,
    year = null,
    refPedido = null,
  ) {
    // Si se proporcionan valores específicos de área, usarlos; si no, usar los del perfil
    const org = vkorg || profile?.AreaVenta?.ORG_VENTA || "0803";
    const canal = vtweg || profile?.AreaVenta?.CANAL_DIST || "06";
    const sector = spart || profile?.AreaVenta?.SECTOR || "03";

    // Para year y refPedido, usar valores proporcionados o vacíos
    const yearValue = year || "";
    const refPedidoValue = refPedido || "";

    const payload = config.recuperarPedido.xml
      .replace("{cliente}", profile.DatosConfig.CUSTOMERNO)
      .replace("{vkorg}", org)
      .replace("{vtweg}", canal)
      .replace("{spart}", sector)
      .replace("{year}", yearValue)
      .replace("{refPedido}", refPedidoValue)
      .replace("{vbeln}", numeroPedido);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  pedirContrasena(cliente) {
    const payload = config.pedirContrasena.xml
      .replace("{cliente}", cliente)
      .replace("{env_usuario}", import.meta.env.VITE_RECUPERAR_PWD_USUARIO)
      .replace("{env_pwd}", import.meta.env.VITE_RECUPERAR_PWD_PASSWORD)
      .replace("{env_app}", import.meta.env.VITE_RECUPERAR_APLICACION);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
      },
    });
  },

  cambiarContrasena(token, cliente, actual, nueva) {
    const payload = config.cambiarContrasena.xml
      .replace("{cliente}", cliente)
      .replace("{actual}", actual)
      .replace("{nueva}", nueva);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  monturas(token, manager) {
    const payload = config.monturas.xml
      .replace("{cliente}", manager.CLIENTESAP)
      .replace("{org}", manager.ORG_VENTA)
      .replace("{canal}", manager.CANAL_DIST)
      .replace("{sector}", manager.SECTOR);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  guardarForma(token, xmlForma) {
    const payload = config.guardarForma.xml.replace("{oClaseApi}", xmlForma);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  buscarForma(token, cliente) {
    const payload = config.buscarForma.xml.replace("{cliente}", cliente);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  saveFavoritos(token, profile, xmlFavoritos) {
    const payload = config.saveFavoritos.xml
      .replace("{cliente}", profile.AreaVenta.CLIENTE)
      .replace("{org}", profile.AreaVenta.ORG_VENTA)
      .replace("{canal}", profile.AreaVenta.CANAL_DIST)
      .replace("{sector}", profile.AreaVenta.SECTOR)
      .replace("{oLista}", xmlFavoritos);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  segundasGafas(token, manager) {
    const payload = config.segundasGafas.xml
      .replace("{cliente}", manager.CLIENTESAP)
      .replace("{org}", manager.ORG_VENTA)
      .replace("{canal}", manager.CANAL_DIST)
      .replace("{sector}", manager.SECTOR);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  pedirExistencia(token, manager, ean11) {
    const payload = config.pedirExistencia.xml
      .replace("{cliente}", manager.CLIENTESAP)
      .replace("{ean11}", ean11);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getRecetas(username, token, profile, dateRange = {}) {
    // Si no se proporcionan fechas, usar valores por defecto razonables (6 meses atrás hasta hoy)
    let fecha_low = dateRange.fecha_low;
    let fecha_hi = dateRange.fecha_hi;

    if (!fecha_low || !fecha_hi) {
      const today = new Date();
      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

      fecha_low = fecha_low || sixMonthsAgo.toLocaleDateString("es-ES");
      fecha_hi = fecha_hi || today.toLocaleDateString("es-ES");
    }


    const payload = config.recetas.xml
      .replace("{username}", username)
      .replace("{cliente}", profile.AreaVenta.CLIENTE)
      .replace("{org}", profile.AreaVenta.ORG_VENTA)
      .replace("{canal}", profile.AreaVenta.CANAL_DIST)
      .replace("{sector}", profile.AreaVenta.SECTOR)
      .replace("{fecha_low}", fecha_low)
      .replace("{fecha_hi}", fecha_hi);


    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  recuperarReceta(username, token, profile, receta, cliente) {
    // Construir el objeto oClaseBAPI solo con RECETA y CLIENTE
    const oClaseBAPI = {
      RECETA: receta,
      CLIENTE: cliente || profile.AreaVenta.CLIENTE,
    };

    // Convertir a XML
    const xmlClaseBAPI = json2xml({ oClaseBAPI });

    // Construir el payload final
    const payload = config.recuperarReceta.xml.replace("{oClaseBAPI}", xmlClaseBAPI);


    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  guardarReceta(username, token, profile, recetaData) {
    // recetaData ya viene procesado desde Vuex, solo convertir a XML directamente
    const xmlClaseBAPI = json2xml(recetaData);

    // Construir el payload final
    const payload = config.guardarReceta.xml.replace("{oClaseBAPI}", xmlClaseBAPI);


    return axios
      .post(axiosConfig.indonetURL, payload, {
        headers: {
          ...axiosConfig.headers,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response.guardarReceta);
  },

  borrarRecetas(token, profile, recetasData) {
    // recetasData debe contener la estructura completa con CLIENTE, ORG_VENTA, etc. y listRECETAS
    const xmlClaseBAPI = json2xml(recetasData);

    // Construir el payload final
    const payload = config.borrarRecetas.xml.replace("{oClaseBAPI}", xmlClaseBAPI);


    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  enviarRecetas(token, profile, recetasData) {
    const xmlClaseBAPI = json2xml(recetasData);

    // Construir el payload final
    const payload = config.enviarRecetas.xml.replace("{oClaseBAPI}", xmlClaseBAPI);


    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  borrarPedido(token, cliente, refPedido, year, vkorg, vtweg, spart, motivoAnulacion) {
    const payload = config.borrarPedido.xml
      .replace(/\{cliente\}/g, cliente)
      .replace(/\{ref_pedido\}/g, refPedido)
      .replace(/\{year\}/g, year)
      .replace(/\{vkorg\}/g, vkorg ?? "")
      .replace(/\{vtweg\}/g, vtweg ?? "")
      .replace(/\{spart\}/g, spart ?? "")
      .replace(/\{motivoAnulacion\}/g, motivoAnulacion ?? "");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  buscarMotivosDevolucionesInadapt(token, vkorg, vtweg, spras) {
    const payload = config.buscarMotivosDevolucionesInadapt.xml
      .replace("{vkorg}", vkorg)
      .replace("{vtweg}", vtweg)
      .replace("{spras}", spras);


    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  crearDevolucionInadapt(devolucion, token) {
    // Convertir OJO a formato del servidor
    const lentes = devolucion.OJO === "OD" ? "D" : devolucion.OJO === "OI" ? "I" : "P";

    const fichaArray = Array.isArray(devolucion.fichaInadaptacion) ? devolucion.fichaInadaptacion : [];
    const datosFichaInadaptacion = fichaArray.map((codigo) => `<string>${codigo}</string>`).join("");

    const payload = config.crearDevolucionInadapt.xml
      .replace("{cliente}", devolucion.CLIENTE || "")
      .replace("{numPedido}", devolucion.VBELN || "")
      .replace("{lentes}", lentes)
      .replace("{motivo}", devolucion.MOTDEV || "")
      .replace("{observaciones}", devolucion.OBSERV || "")
      .replace("{pedirRecogida}", "false")
      .replace("{fechaCliente}", devolucion.FECCLI || new Date().toISOString())
      .replace("{ofertaDevolucion}", devolucion.OFEDEV || "")
      .replace("{datosFichaInadaptacion}", datosFichaInadaptacion);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  buscarNumeroRecogidas(cliente, organizacion, canal, sector, token) {
    const payload = config.buscarNumeroRecogidas.xml
      .replace("{cliente}", cliente)
      .replace("{organizacion}", organizacion)
      .replace("{canal}", canal)
      .replace("{sector}", sector);

    return axios
      .post(axiosConfig.indonetURL, payload, {
        headers: {
          ...axiosConfig.headers,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response.buscarNumeroRecogidas);
  },
  crearRecogida(
    cliente,
    organizacion,
    canal,
    sector,
    tipo,
    origen = "I",
    sConLentes = "",
    destinatario,
    token,
  ) {
    const payload = config.crearRecogida.xml
      .replace("{cliente}", cliente)
      .replace("{organizacion}", organizacion)
      .replace("{canal}", canal)
      .replace("{sector}", sector)
      .replace("{tipo}", tipo)
      .replace("{origen}", origen)
      .replace("{sConLentes}", sConLentes)
      .replace("{destinatario}", destinatario);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  buscarDevolucionesTramitadas(cliente, organizacion, canal, sector, filtros, token) {
    const payload = config.buscarDevolucionesTramitadas.xml
      .replace("{cliente}", cliente || "")
      .replace("{organizacion}", organizacion || "")
      .replace("{canal}", canal || "")
      .replace("{sector}", sector || "")
      .replace("{numPedido}", filtros.numPedido || "")
      .replace("{numDevolucion}", filtros.numDevolucion || "")
      .replace("{estado}", filtros.estado || "")
      .replace("{fechaRecLow}", filtros.fechaRecLow || "")
      .replace("{fechaRecHi}", filtros.fechaRecHi || "")
      .replace("{fechaRec1Low}", filtros.fechaRec1Low || "")
      .replace("{fechaRec1Hi}", filtros.fechaRec1Hi || "")
      .replace("{fechaRec2Low}", filtros.fechaRec2Low || "")
      .replace("{fechaRec2Hi}", filtros.fechaRec2Hi || "")
      .replace("{campoOrden}", filtros.campoOrden || "FECHA_REC")
      .replace("{ordenacion}", filtros.ordenacion || "D");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getComercialFoto(email, token) {
    const payload = config.getComercialFoto.xml.replace("{email}", email);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  datosBuscadorWeb(datosJson, token) {
    const payload = config.datosBuscadorWeb.xml.replace("{datos_json}", datosJson);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAlertasCliente(cliente, token) {
    const payload = config.getAlertasCliente.xml.replace("{sCliente}", cliente);

    return axios
      .post(axiosConfig.indonetURL, payload, {
        headers: {
          ...axiosConfig.headers,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response.getAlertasCliente);
  },

  requestInformacionFiscal(cliente, tipo, token,anyo) {
    const payload = config.requestInformacionFiscal.xml
      .replace("{cliente}", String(cliente))
      .replace("{anyo}", String(anyo))
      .replace("{tipo}", tipo)
      .replace("{idioma}", getSoapIdioma());

    return axios
      .post(axiosConfig.indonetURL, payload, {
        headers: {
          ...axiosConfig.headers,
          Authorization: `Bearer ${token}`,
        },
      })
      .then(response.requestInformacionFiscal);
  },

  async recuperarAlbaran(numeroAlbaran, username, manager, token) {
    const payload = config.recuperarAlbaran.xml
      .replace("{pedido}", numeroAlbaran)
      .replace("{cliente}", manager.CLIENTE)
      .replace("{solicitante}", "")
      .replace("{usuario}", import.meta.env.VITE_USUARIO_ALBARAN)
      .replace("{pwd}", import.meta.env.VITE_PWD_ALBARAN);

    return axios.post(axiosConfig.indoboxURL, payload, {
      headers: {
        ...axiosConfig.headers,
        SOAPAction: "http://WSINDOBOX.es/RecuperarAlbaran",
      },
    });
  },

  buscarListaClientes(token, manager) {
    const payload = config.buscarListaClientes.xml
      .replace("{cliente_manager}", manager.CLIENTE || manager.CLIENTESAP)
      .replace("{org_ventas}", getOrgVentasFromUrl())
      .replace("{canal}", manager.CANAL_DISTRIBUCION)
      .replace("{sector}", manager.SECTOR)
      .replace("{idioma}", "ES");

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
      silentError: true,
    });
  },

  abrirReclamacionFactura(token, cliente, nombreCliente, factura, fechaFactura, observaciones) {
    const payload = config.abrirReclamacionFactura.xml
      .replace("{cliente}", cliente)
      .replace("{nombre_cliente}", nombreCliente)
      .replace("{factura}", factura)
      .replace("{fecha_factura}", fechaFactura)
      .replace("{observaciones}", observaciones);

    return axios.post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
};

export function recuperarPedido({ CLIENTE, VKORG, VTWEG, SPART, YEAR, REF_PEDIDO, VBELN }, token) {
  const payload = config.recuperarPedido.xml
    .replace("{cliente}", CLIENTE)
    .replace("{vkorg}", VKORG)
    .replace("{vtweg}", VTWEG)
    .replace("{spart}", SPART)
    .replace("{year}", YEAR)
    .replace("{refPedido}", REF_PEDIDO)
    .replace("{vbeln}", VBELN);

  return axios
    .post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    })
    .then(response.recuperarPedido);
}
/**
 * Guarda datos BigExact en SAP
 * @param {Object} params - Parámetros del BigExact
 * @param {string} params.cliente - Cliente SAP
 * @param {string} params.ref_pedido - Referencia del pedido
 * @param {string} params.idl_bigexact - ID BigExact
 * @param {string} params.dispositivo - Dispositivo
 * @param {string} params.fecha - Fecha
 * @param {string} params.xml_content - Contenido XML
 * @param {string} token - Token de autenticación
 * @returns {Promise} - Respuesta del servicio
 */
export function guardarDatosBIGEXACT(
  { cliente, ref_pedido, idl_bigexact, dispositivo, fecha, xml_content },
  token,
) {

  const payload = config.guardarDatosBIGEXACT.xml
    .replace("{cliente}", cliente)
    .replace("{ref_pedido}", ref_pedido)
    .replace("{idl_bigexact}", idl_bigexact)
    .replace("{dispositivo}", dispositivo)
    .replace("{fecha}", fecha)
    .replace("{xml_content}", xml_content);


  return axios
    .post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    })
    .then(response.guardarDatosBIGEXACT);
}

/**
 * Carga datos BigExact desde SAP
 * @param {Object} params - Parámetros del BigExact
 * @param {string} params.idl_bigexact - ID BigExact
 * @param {string} token - Token de autenticación
 * @returns {Promise} - Respuesta del servicio
 */
export function cargarDatosBIGEXACT({ idl_bigexact }, token) {
  const payload = config.cargarDatosBIGEXACT.xml.replace("{idl_bigexact}", idl_bigexact);

  return axios
    .post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    })
    .then(response.cargarDatosBIGEXACT);
}
export function getComercialFoto(email, token) {
  const payload = config.getComercialFoto.xml.replace("{email}", email);

  return axios
    .post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    })
    .then(response.getComercialFoto);
}

export function getDescripcionTratamiento(
  VKORG,
  CodigoTratamiento,
  CodigoCaract,
  CarAdiccional,
  token,
) {
  const payload = config.getDescripcionTratamiento.xml
    .replace("{VKORG}", VKORG || "")
    .replace("{CodigoTratamiento}", CodigoTratamiento || "")
    .replace("{CodigoCaract}", CodigoCaract || "")
    .replace("{CarAdiccional}", CarAdiccional || "");

  return axios
    .post(axiosConfig.indonetURL, payload, {
      headers: {
        ...axiosConfig.headers,
        Authorization: `Bearer ${token}`,
      },
    })
    .then(response.getDescripcionTratamiento);
}
